/*
	After some async processes, we sometimes receive notifications that there are new Assets
	added to a library, and we need to inject them into the store to be displayed in grids.
*/

import { Assets } from "reducers/Assets";
import { useDispatch, useSelector } from "react-redux";
import useFTMessage from "hooks/Notification";
import { JCRM_SOCKET } from "utils/constants";

const uploadTerminalStatusNames = [
	"Success",
	"warn",
	"Failed",
];

export function useAssetSocket(){
	const dispatch = useDispatch();
	const currentLibraryId = useSelector(state => state.libraryProperties.id);

	useFTMessage(({ detail }) => {
		let { message } = detail;

		if(message.origin === JCRM_SOCKET){
			if(!/encode video/gi.test(message.task) && !/upload video/i.test(message.task)){ return; }
			if(!/success/gi.test(message.status)){ return; }

			dispatch(Assets.addSocketAsset(message.data?.creativeLibrary, message.data?.asset));
		}

		if(message.origin === "HOPI"){
			if((message.task === "Upload Assets") && uploadTerminalStatusNames.includes(message.status)){
				/*
					This is a bulk asset upload batch completion, and we need to refresh the whole Assets grid
					because we don't have more targeted data to inject, because the upload endpoints
					don't return anything after successful upload
				*/
				let { libraryId } = message.data;

				if(parseInt(libraryId) === parseInt(currentLibraryId)){
					dispatch(Assets.loadAssets(libraryId));
				}
			}
		}
	});
}

export function AssetSocketListener({ children }){
	useAssetSocket();

	return children;
}
